import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "trial_count",
  "areacode",
  "zipcode",
  "old_msisdn",
  "new_msisdn",
  "last_updated",
];

const TelitChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    client={CLIENTS.telit}
    columnsFactory={changeNumberColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showTerminate
    showCheckStatus
    checkStatusOperation="change_number"
    getRowPath={(row) => `/telit/change_number/${row.id}`}
  />
);

export default TelitChangeNumberBatch;
